/**
 * 视频上传获取视频首帧组件
 * @description
 * @author yly
 * @date 2023-03-29
 */
import React from 'react';
import { connect } from 'dva';
import { Button } from 'antd';
import { component_tool, framework_tool } from '../../../tool'
let { WizIcon, WizButton, WizRadio } = component_tool;
let { WizContainer } = framework_tool;
const { WizOssUpload, modelUtils, ossFileUtils } = framework_tool;
const { getOssUrlBySuffix } = ossFileUtils

import './index.less'

class UploadVideoToPic extends WizContainer {
  componentName = 'UploadDemo';
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      fileList: [], //文件列表
      img: '', //图片
      // checkUse: 0,//是否作为封面图使用
      videoBol: false,//是否是视频
      judgeList: [],
      changeVideoTime : new Date().getTime()
    };
  }

  componentWillMount() {
    const { value, imgValue,
      //  coverUse
    } = this.props
    console.log(value, 'value')
    if (!value || !value.length) return
    const fileList = value.map(val => {
      return {
        uid: val.fileId,
        name: val.fileName,
        url: getOssUrlBySuffix(val.fileUri),
        status: "done",
      };
    });
    this.setState({ fileList });
    this.setState({ judgeList: fileList });
    if (!imgValue || !imgValue.length) return
    let img = imgValue[0].fileId
    this.setState({ img });
    // if (!coverUse) return
    // const checkUse = coverUse
    // this.setState({ checkUse });
  }

  propsAndStateOnChange = {
    uploadValue: this._uploadValue.bind(this)
  }
  _uploadValue(nextProps, nextState) {
    let { code, data, msg } = nextProps.uploadValue
    if (code === 1) {
      const { onChange } = this.props;
      this.setState({ img: data[0].fileId });
      onChange({
        fileId: [{ fileId: data[0].fileId }],
        contentText: this.state.fileList,
        checkUse: 0,
      });
    } else {
      wizNotice.error(msg || '图片截取首帧失败,请稍后尝试')
    }
    return true
  }
  // 视频上传变化
  handleUploadVideoOnChange = values => {
    this.setState({ judgeList: [values] })
    if (!values.length) {
      this.setState({ img: '' });
      this.videoOnChange([])
      this.setState({ videoBol: false });
      this.setState({ judgeList: [] })
      return
    }
    const _value = values[values.length - 1];
    if (_value && _value.status !== "done") return;
    if (_value && _value.fileNewName && _value.fileNewName.indexOf('mp4') > -1) {
      this.setState({ fileList: values }, () => {
        this.videoOnChange([_value]);
      });
    } else {
      this.setState({ fileList: values })
      const { onChange } = this.props;
      onChange &&
        onChange({
          fileId: [{ fileId: this.state.img }],
          checkUse: 0,
          contentText: values,
        });
      this.setState({ videoBol: false })
    }
  };
  /**
  * 获取Blob对象
  * @param {*} url
  * @param {*} callback
  */
  getBlob = (url, callback) => {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      callback(xhr.response)
    }
    xhr.send()
  }
  // 上传视频状态变化时 改变表单状态
  videoOnChange = (values) => {
    const { onChange } = this.props;
    onChange &&
      onChange({
        fileId: values?.length > 0 ? [{ fileId: this.state.img }] : [],
        checkUse: 0,
        contentText: values,
      });
    if (values && values.length > 0) {
      const _value = values[values.length - 1];
      this.getBlob(
        //getVideoCoverPublic(videoPath, `,w_${width},h_${height},ar_${width > height ? 'w' : 'h'}`)
        getVideoCover(_value.fileId)
        , (e) => {
          let file = new File([e], new Date().getTime() + '.jpg', { type: 'image/jpg' })
          const form = new FormData();
          form.append("file", file);
          this.doAction({
            path: 'fileUpload/upload',
            payload: {
              key: 'fileUpload@upload',
              apiParams: form
            }
          })
        })
      this.setState({ videoBol: true })
    }
  };
  formatText = (text) => {
    let desc = ''
    if (text) {
      desc = text.split('.').join('')
    }
    return desc
  }
  checkChange = () => {
    const { onChange } = this.props;
    // this.setState({ checkUse: e.target.value })
    onChange && onChange({
      fileId: [{ fileId: this.state.img }],
      contentText: this.state.fileList,
      checkUse: 1,
    })
  }
  judgeUpload = (file) => {
    let { fileTypeStr } = this.props
    let result = true;
    let nameArr = file.name.split('.')
    let nameType = nameArr[nameArr.length - 1]
    if (this.state.fileList && this.state.fileList.length > 14) {
      wizNotice.error('最多上传15个文件');
      result = false;
    } else if (fileTypeStr.indexOf(nameType) == -1) {
      wizNotice.error(`只能上传${fileTypeStr}文件`);
      result = false;
    }
    return result;
  }
  _render() {
    let { fileList, img ,changeVideoTime} = this.state
    let { fileTypeStr } = this.props
    return (
      <div className='upload-video-to-pic'>
        <div className='upload-out'>
          <div className='upload-left'>
          <WizOssUpload
            key={changeVideoTime || 'videoFile'}
            style={{ margin: "0 10px" }}
            onChange={this.handleUploadVideoOnChange}
            multiple={false}
            value={fileList}
            accept={fileTypeStr ? fileTypeStr : ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp4, .mov,"}
            // accept={".mp4, .AVI, .mov, .rmvb, .rm, .FLV, .3GP, .MPEG, .WMV"}
            uploadType={"temp"} //⭐️表示临时储存空间，正式业务请根据场景自行传入
            beforeUpload={(file,upload,remove) => {
              if (!this.judgeUpload(file)) {
                remove && remove()
                this.setState({
                  changeVideoTime: new Date()
                })
                return false;
              } else {
                const isLt1M = file.size / 1024 / 1024 / 1024 < 4;
                if (!isLt1M) {
                  remove && remove()
                  this.setState({
                    changeVideoTime: new Date()
                  })
                  Wizmessage.error('视频大小不得超过4G!');
                  return false;
                }
                return isLt1M;
              }
            }}
          >
            <WizButton>
              <WizIcon type="upload" />
              点击上传
            </WizButton>
          </WizOssUpload>
          </div>
          <div className='upload-text'>(支持上传{this.formatText(fileTypeStr)}文件)</div>
        </div>
        {this.state.videoBol && img ?
          <div>
            <img className='to-pic' src={getOssFilePath(img)}></img>
            <div className='button-out'>
              <Button type="primary" onClick={() => this.checkChange()}>设为封面</Button>
              {/* <WizRadio.Group onChange={this.checkChange} value={checkUse}>
                <WizRadio value={0}>否</WizRadio>
                <WizRadio value={1}>是</WizRadio>
              </WizRadio.Group> */}
            </div>
          </div>
          : ''}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { fileUpload } = state
  const uploadValue = modelUtils.getModelEntity(fileUpload, 'fileUpload@upload')

  return {
    uploadValue
  };
};

export default connect(mapStateToProps)(UploadVideoToPic);
